import React, { useContext, useEffect, useState } from 'react';
import Sidebar from '../../Components/SideBar';
import { Container, Row, Col, Card, Button, Table, Alert } from 'react-bootstrap';
import Slider from '../../Components/Slider';
import DemoModal from '../../Components/DemoModal/DemoModal';
import ContactModal from '../../Components/ContactModal/ContactModal';
import BannerAlert from '../../Components/BannerAlert/BannerAlert';
import ButtonsHome from '../../Components/ButtonsHome/ButtonsHome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar as faStaro } from '@fortawesome/free-regular-svg-icons';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import SingleCard from '../../Components/SingleCard';
import Slide1 from '../../Assets/slider/side1.png';
import iconexplore from '../../Assets/ex.svg'
import { ExploreContext } from '../../Context/ExploreContext';
import { App, Tag } from '../../interface';
import { UserContext } from '../../Context/UserContext';
import BannerViewAs from '../../Components/BannerViewAs';
import Header from '../../Components/Header';
import { fileURLToPath } from 'url';
import { useLocation, useNavigate } from 'react-router-dom';
import { removeCharacter } from '../../util/chunk';
import SortableTable from '../../Components/Tables/SrotTable';
import ChatBot from '../../Components/ChatBot/ChatBot';
import ChatToggle from '../../Components/ChatBot/ChatToggle';

const Index: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { getAppsByUser, appsByUser, createFavorite, deleteFavorite } = useContext(ExploreContext);
  const { getUserData, userData, getUserDataViewas,permissionsData } = useContext(UserContext);

  const [selectedParentApp, setSelectedParentApp] = useState<{ id: number | null, name: string }>({ id: null, name: 'All Applications' });

  const [collapsed, setCollapsed] = useState(false);
  const [isGridView, setIsGridView] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const handleModal = () => setShowModal(!showModal);
  const [showModalContact, setShowModalContact] = useState(false);
  const handleModalContact = () => setShowModalContact(!showModal);
  const [data, setData] = useState<App[]>([]);
  const [uniqueTags, setUniqueTags] = useState<Tag[]>([]);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [filteredData, setFilteredData] = useState<App[]>([]);
  const [tagSelected, setTagSelected] = useState<string>();
  const [isFilteredFav, setIsFilteredFav] = useState<boolean>(false);
  const [dataDemo, setDataDemo] = useState<any>([]);
  const [viewAsData, setViewAsData] = useState<any>();
  const [nameSection, setNameSection] = useState<any>("Favorites");
  const [prevFilteredData, setPrevFilteredData] = useState<App[]>([]);
  const [isEmpt, setIsEmpt] = useState(false);
  const images = [Slide1];
  const [chatPermissions, setChatPermissions] = useState(false);
  const [userDataViewas, setUserDataViewas] = useState<any>(null);
  const [isOpenbot, setIsOpenbot] = useState(false);
  const [isFull, setIsFull] = useState(false);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const toggleView = () => {
    setIsGridView(!isGridView);
  };

  const getData = async () => {
    const aValue = localStorage.getItem("okta-token-storage")!;
    const oktadata = JSON.parse(aValue);
    const okta_id = oktadata.idToken.claims.sub;
    // let user = await getUserData(okta_id)
    
    const userView = localStorage.getItem("userView")!;
    let apps;
    if (userView != null) {
      let userViewAs = await getUserDataViewas(userView)
      setUserDataViewas(userViewAs)
      apps = await getAppsByUser(userViewAs.id, userData?.id);
    } else {
      apps = await getAppsByUser(userData?.id);
    }

    if (apps instanceof Error) {
      console.error("Error fetching apps", apps);
    } else {

    }

  };

  function getUniqueTags(apps: App[]): Tag[] {
    const tagMap = new Map<string, Tag>();

    apps.forEach(app => {
      if (app.tags)
        app.tags.forEach(tag => {
          if (!tagMap.has(tag.tag_description)) {
            tagMap.set(tag.tag_description, tag);
          }
        });
    });

    return Array.from(tagMap.values());
  }
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 1000) {
        setCollapsed(true);
      } else {
        setCollapsed(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (userData) {
      const userView = localStorage.getItem('userView')
      const nameView = localStorage.getItem('nameView')
      const viewAss = localStorage.getItem('viewAss')
      setViewAsData({
        userView: userView || null,
        nameView: nameView || null,
        viewAss: viewAss || null,
      });
      const locationFilter = location.state?.filter;
      if (locationFilter === 'favorites') {
        handleFilterFav('favorites');
      } else if (locationFilter === 'all') {
        handleFilterFav('all');
      }
      getData();
    }
  }, [userData]);

  useEffect(() => {
    if (location.state) {
      const { parentAppId, parentAppName, filter } = location.state as {
        parentAppId?: number;
        parentAppName?: string;
        filter?: string;
      };

      if (parentAppId && parentAppName) {
        setSelectedParentApp({ id: parentAppId, name: parentAppName });
        setFilteredData(data.filter(app => app.parent_app_id === parentAppId));
        setNameSection(parentAppName);
      } else if (filter) {
        handleFilterFav(filter);
      }
    }
    if (window.innerWidth <= 1000) {
      setCollapsed(true);
    }
  }, [location.state]);

  const handleSearch = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const term = event.target.value.toLowerCase();
    setSearchTerm(term);

    if (term === '') {
      setFilteredData(prevFilteredData);
      setPrevFilteredData([])
    } else {
      if (!prevFilteredData.length) {
        setPrevFilteredData(filteredData);
      }

      const filtered = filteredData.filter(app =>
        app.app_name?.toLowerCase().includes(term) ||
        (app.app_description && app.app_description.toLowerCase().includes(term))
      );
      setFilteredData(filtered);
    }
  };
  const handleSearchTag = (tagDescription: string) => {
    setIsFilteredFav(false);
    setSearchTerm('')
    if (tagDescription === '' || tagDescription == tagSelected) {
      setFilteredData(data);
      setTagSelected('')
    } else {
      setTagSelected(tagDescription)
      const filtered = data.filter(app =>
        app.tags?.some(tag => tag.tag_description === tagDescription)
      );
      setFilteredData(filtered);
    }
  };

  const handleFilterFav = (filter: string) => {
    setTagSelected('');
    setSearchTerm('');
    setIsFilteredFav(filter === 'favorites');

    if (filter === 'favorites') {
      const filtered = data.filter(app => app.favorites && app.favorites.length > 0)

      setFilteredData(filtered);
      setNameSection('Favorites');
    } else if (filter === 'all') {
      setFilteredData(data); // Muestra toda la data
      setNameSection('All Applications');
    }
    if (window.innerWidth <= 1000) {
      setCollapsed(true);
    }

  };

  const handleFavorites = async (appid: number, deleteFav: boolean) => {
    const aValue = localStorage.getItem("okta-token-storage")!;
    const oktadata = JSON.parse(aValue);
    const okta_id = oktadata.idToken.claims.sub;
    let user = await getUserData(okta_id);
    const userView = localStorage.getItem("userView")!;
    let result;

    if (deleteFav) {
      if (userView) {
        let userViewAs = await getUserDataViewas(userView);
        result = await deleteFavorite(userViewAs.id, appid, user.id);
      } else {
        result = await deleteFavorite(user.id, appid);
      }
    } else {
      if (userView) {
        let userViewAs = await getUserDataViewas(userView);
        result = await createFavorite(userViewAs.id, appid, user.id);
      } else {
        result = await createFavorite(user.id, appid);
      }
    }

    if (result.success) {
      setData(prevData => {
        const updatedData = prevData.map(app =>
          app.id === appid
            ? {
              ...app,
              favorites: deleteFav ? [] : [...(app.favorites ?? []), { user_id: user.id }]
            }
            : app
        ) as App[];

        // 🔹 Mantener el filtro de la sección actual
        if (selectedParentApp.id) {
          setFilteredData(updatedData.filter(app => app.parent_app_id === selectedParentApp.id));
        } else if (isFilteredFav) {
          setFilteredData(updatedData.filter(app => app.favorites && app.favorites.length > 0));
        } else {
          setFilteredData(updatedData);
        }

        return updatedData;
      });

      // Mantener el nombre de la sección
      if (selectedParentApp.id) {
        setNameSection(selectedParentApp.name);
      }
    } else {
      alert(result.message);
    }
  };






  const handleMultipleApps = (id: number, name: string) => {
    setSelectedParentApp({ id, name }); // Guardar selección
    setFilteredData(data.filter(item => item.parent_app_id === id)); // Mantener el filtro activo
    setNameSection(name);

    if (window.innerWidth <= 1000) {
      setCollapsed(true);
    }

  };

  const openApp = (url: string, secondaryUrl?: string | null) => {

    window.open(url, '_blank');

  };





  useEffect(() => {
    if (appsByUser) {
      setData(appsByUser.data);
      const tags = getUniqueTags(appsByUser.data);
      setUniqueTags(tags);

      // Solo aplicar el filtro de favoritos si el usuario está en la sección de favoritos
      if (nameSection === "Favorites") {
        const filtered = appsByUser.data.filter((app: { favorites: string | any[]; }) => app.favorites && app.favorites.length > 0);
        setFilteredData(filtered);
        if (filtered.length == 0) {

          setIsEmpt(true)
        } else {
          setIsEmpt(false)
        }
      } else {
        // Mantener la lista actual sin resetear a favoritos
        setFilteredData(prevFilteredData => {
          return prevFilteredData.length ? prevFilteredData : appsByUser.data;
        });
      }
    }
  }, [appsByUser, nameSection]);  

  const hasPermission = (userData: any, permissionsData: any) => {
    if (!permissionsData) return false;
  
    const roleIds = permissionsData.role_id?.split(',') || [];
    const institutionIds = permissionsData.institution_id?.split(',') || [];
  
    // Verificar si hay una propiedad "users" válida
    let userPermissions: Record<string, any> = {};
    if (permissionsData.users) {
      try {
        userPermissions = JSON.parse(permissionsData.users);
      } catch (err) {
        console.error("Error parsing permissionsData.users", err);
      }
    }
  
    // Obtener el usuario en modo vista (si existe)
    const userView = localStorage.getItem("userView");
    const activeUser = userView ? userDataViewas : userData;
  
    if (!activeUser) return false;
  
    // Verifica tres condiciones:
    if (userPermissions.hasOwnProperty(activeUser.id?.toString())) { 
      return true; 
    } else {
      return (
      roleIds.includes(activeUser.qlik_role_id?.toString()) &&
      institutionIds.includes(activeUser.account?.id?.toString())
    );
    }
    
  };
  
  

  useEffect(() => {
    if(userData && permissionsData) {
      const hasPerm = hasPermission(userData, permissionsData);
      setChatPermissions(hasPerm);
      
    }
  
  }, [userData, permissionsData, userDataViewas]);


  return (
    <Container fluid className='position-relative' style={{ minWidth: "350px" }}>
      {/* <BannerAlert /> */}
      <Header toggleSidebar={toggleSidebar} collapsed={collapsed} />
      <Row>
        <Col className={`p-0 sidebar-container ${collapsed ? "collapsed-side" : "open "}`}>
        
          <Sidebar
            collapsed={collapsed}
            onToggle={toggleSidebar}
            handleMultipleApps={handleMultipleApps}
            handleFav={handleFilterFav}
          />
        </Col>

        <Col className="px-3 transition-all main-container">
          {viewAsData?.nameView != null && <BannerViewAs nameUser={viewAsData.nameView} />}
          {/* <BannerAlert /> */}
          <div className='mb-4'>
            <div className='pt-3 d-flex justify-content-between align-items-center position-sticky sticky-top bg-white z-1' >
                <div className='col-6'>
              {chatPermissions &&  (  
                <>
                {!isOpenbot&&<ChatToggle setIsOpenbot={setIsOpenbot} />}
                </>
              )}
              </div>
              <div className='col-6'>

                <ButtonsHome
                  name={""}
                  data={uniqueTags}
                  toggleView={toggleView}
                  isGridView={isGridView}
                  handleSearch={handleSearch}
                  searchTerm={searchTerm}
                  handleSearchTag={handleSearchTag}
                  tagSelected={tagSelected}
                  handleFav={() => handleFilterFav('favorites')}
                  isFilteredFav={isFilteredFav} />
              </div>
            </div>

            <Row>
              {chatPermissions && (

            <div className={`${isFull ? 'col-12':'col-6'} ${isOpenbot ? 'visible' : 'hidden'}`}>
            <ChatBot isOpen={isOpenbot}  setIsOpenbot={setIsOpenbot} setFull={setIsFull} isFull={isFull} />
              </div>
              )}

              <div className={(isOpenbot && !isFull) ? 'col-6' : 'col-12'}>
                <div>
                  <h4>{nameSection}</h4>
                </div>
                {isGridView ? (
                  <div className='d-flex flex-wrap mt-2'>

                    {filteredData && filteredData.map((item, index) => (
                      <div key={index} className="mb-3">
                        <Card className='card-app cursor-pointer' onClick={() => openApp(item.selected_link ? item.selected_link : '', item.oktaAppLink)}>
                          <Card.Img />
                          <Card.Body className='position-relative bg-cs d-flex justify-content-center align-items-center'>
                            <Card.Title>{item.app_name}</Card.Title>

                            {/* Ícono de "star" que NO activa el click del Card */}
                            {item.favorites && item.favorites.length > 0 ? (
                              <a onClick={(e) => { e.stopPropagation(); handleFavorites(item.id, true); }} className='btn-favorites'>
                                <FontAwesomeIcon className='favorite cursor-pointer' icon={faStar} size="lg" />
                              </a>
                            ) : (
                              <a onClick={(e) => { e.stopPropagation(); handleFavorites(item.id, false); }} className='btn-favorites'>
                                <FontAwesomeIcon className='favorite cursor-pointer' icon={faStaro} size="lg" />
                              </a>
                            )}
                          </Card.Body>
                        </Card>
                      </div>
                    ))}
                    {(isEmpt == true && nameSection == "Favorites") ? (<div className='d-flex justify-content-center flex-column align-items-center  w-100 mt-5'>
                      <h1>You don't have favorite apps</h1>
                      <h3>Click on the star button of the app cards to add them in this section</h3>
                    </div>) : null}
                  </div>
                ) : (
                  <SortableTable data={filteredData} openApp={openApp} />
                )}
              </div>
            </Row>

          </div>
        </Col>
      </Row >


      {/* <DemoModal showModal={showModal} handleModal={handleModal} />
      <ContactModal showModal={showModalContact} handleModal={handleModalContact} /> */}
    </Container >
  );
};

export default Index;
